import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { Icon } from '@redturtle/iovisit-theme/components';

const messages = defineMessages({
  starting_from: { id: 'itinerary_start_from', defaultMessage: 'Partenza da' },
  tour_length: { id: 'itinerary_tour_length', defaultMessage: 'Lunghezza' },
  duration: { id: 'itinerary_duration', defaultMessage: 'Durata' },
  suitable_for: { id: 'itinerary_suitable_for', defaultMessage: 'Adatto a' },
});

const SummaryInfos = ({ content }) => {
  const intl = useIntl();

  const showItineraryInfo =
    content?.starting_from ||
    content?.tour_length ||
    content?.duration ||
    content?.suited_to?.length > 0;

  return showItineraryInfo ? (
    <div className="leadimage-more">
      <Container>
        <div className="itinerary-infos">
          {content?.starting_from && (
            <div className="info">
              <Icon prefix="fas" icon="map-pin" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.starting_from)}
              </div>
              <div className="value">{content?.starting_from}</div>
            </div>
          )}

          {content?.tour_length && (
            <div className="info">
              <Icon prefix="fas" icon="arrows-alt-h" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.tour_length)}
              </div>
              <div className="value">{content?.tour_length}</div>
            </div>
          )}

          {content?.duration && (
            <div className="info">
              <Icon prefix="fas" icon="stopwatch" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.duration)}
              </div>
              <div className="value">{content?.duration}</div>
            </div>
          )}

          {content?.suited_to && content?.suited_to?.length > 0 && (
            <div className="info">
              <Icon prefix="fas" icon="users" className="icon" />
              <div className="title">
                {intl.formatMessage(messages.suitable_for)}
              </div>
              <div className="value">
                {content?.suited_to?.map(
                  (el, index) =>
                    `${el.title}${index + 1 < content?.suited_to.length ? ', ' : ''}`,
                )}
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  ) : null;
};

export default SummaryInfos;
